import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from '@ngrx/store';
import { DialogService } from '@prism/angular-shared';
import { catchError, map, mergeMap, of, retry } from 'rxjs';
import { CoreActions } from '.';
import { UserApiService } from '../../services/user-api.service';


@Injectable({ providedIn: 'root' })
export class CoreEffects {

    constructor(
        public store: Store,
        private actions$: Actions,
        private userApiService: UserApiService,
        private router: Router,
        private dialog: DialogService<void>,
    ) { }



    loadCurrentUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CoreActions.LoadCurrentUser),
            mergeMap(({ userId }) => this.userApiService.getUserById(userId).pipe(
                map((user) => CoreActions.LoadCurrentUserSuccess({ user })),
                catchError((error) => of(CoreActions.LoadCurrentUserError({ error })))
            ))
        )
    )

    /* Retried, because a failure here is not recoverable on its own: LoadUsersError leaves
       users as [] and nothing re-dispatches within a session, so one blip blanks every
       toUserName/toUserImage binding in the app until the tab is reloaded. */
    loadUsers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CoreActions.LoadUsers),
            mergeMap(() => this.userApiService.getUsers().pipe(
                retry({ count: 3, delay: 1000 }),
                map((users) => CoreActions.LoadUsersSuccess({ users })),
                catchError((error) => of(CoreActions.LoadUsersError({ error })))
            ))
        )
    )

    loadUserById$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CoreActions.LoadUserById),
            mergeMap(({ userId }) => this.userApiService.getUserById(userId).pipe(
                map((user) => CoreActions.LoadUserByIdSuccess({ user })),
                catchError((error) => of(CoreActions.LoadUserByIdError({ error })))
            ))
        )
    )

}
